module.exports = __webpack_public_path__ + "img/TedXiaoPhD.df622d8a.png";